import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ButtonToggleConfig } from './button-toggle.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: [
    '../button/button.component.scss',
    './button-toggle.component.scss',
  ],
})
export class ButtonToggleComponent implements OnInit {
  @Input() config: ButtonToggleConfig;
  @Input() isSelected: boolean;

  @Output() buttonToggleClicked: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    const [config] = checkInputsForText([this.config]);

    this.config = config;
  }

  onClick() {
    this.isSelected = !this.isSelected;
    this.buttonToggleClicked.emit(this.isSelected);
  }

  getApplicableConfig() {
    return this.isSelected ? this.config.selected : this.config.unselected;
  }

  getIconFill(): string {
    return this.config.style === 'button'
      ? 'btn-high__icon--resting'
      : this.isSelected
        ? 'toggle-active-text-color'
        : 'toggle-active-background';
  }
}
